const updates = [
  { time: '刚刚', content: '某知名导演新片选角内幕曝光，多位一线演员参与角逐主角', tag: '影视圈' },
  { time: '10分钟前', content: '直播平台头部主播合约纠纷升级，双方各执一词互不相让', tag: '直播圈' },
  { time: '28分钟前', content: '热门恋爱综艺素人嘉宾身份遭起底，节目组回应称将核实', tag: '综艺' },
  { time: '45分钟前', content: '知名品牌代言人疑似翻车，品牌方连夜删除所有合作内容', tag: '商业' },
  { time: '1小时前', content: '某男团成员私联粉丝录音曝光，经纪公司发布律师函警告', tag: '娱乐圈' },
  { time: '2小时前', content: '短视频平台流量造假产业链被揭开，涉及金额或达数千万', tag: '互联网' },
  { time: '3小时前', content: '网络小说改编剧选角争议持续发酵，原著粉丝集体抵制', tag: '影视圈' },
  { time: '5小时前', content: '跨界艺人商业版图再扩张，知情人士爆料新项目涉及海外市场', tag: '商业' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            24小时滚动更新，吃瓜永不掉队
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-primary-200/60"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-0 top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
                <div className="flex-1 min-w-0 bg-background-50 border border-background-200/50 rounded-lg p-3.5 md:p-4 hover:border-primary-200/50 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}